import React from 'react'
import PropTypes from 'prop-types'

const IframeBlock = ({url, rootURL, id, heightFrame, widgetId, dialogId, paramsApp}) => {
  let urlFrame = url.trim()
  const paramsAppInString = Object
    .keys(paramsApp)
    .filter(key => ['rootURL', 'platform'].some(keyIgnore => key !== keyIgnore))
    .map(key => `${key}=${encodeURIComponent(paramsApp[key])}`)

  urlFrame = urlFrame + '&'+ paramsAppInString.join('&')
  if(urlFrame.indexOf('userToken') === -1){
    urlFrame = urlFrame + `&userToken=${localStorage.user}`
  }
  if(urlFrame.indexOf('frameId') === -1){
    urlFrame = urlFrame + `&frameId=${id}`
  }
  if(urlFrame.indexOf('pageUri') === -1){
    urlFrame = urlFrame + `&pageUri=${rootURL}`
  }
  if(urlFrame.indexOf('widgetID') === -1){
    urlFrame = urlFrame + `&widgetID=${widgetId}`
  }

  if(urlFrame.includes('name=estimation') && `${dialogId}`.length && !urlFrame.includes('&dialogID=')) {
    urlFrame = urlFrame + `&dialogID=${dialogId}`
  }

  return (
    <div className="iframe-container">
      <iframe
        title={`${new Date().getTime()}`}
        width='100%'
        height={heightFrame + 'px'}
        src={urlFrame}
        scrolling="no"
      />
    </div>
  )
}

IframeBlock.propTypes = {
  url: PropTypes.string.isRequired,
  rootURL: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  heightFrame: PropTypes.number.isRequired,
  widgetId: PropTypes.string.isRequired,
  babyToken: PropTypes.string.isRequired,
  dialogId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  paramsApp: PropTypes.object
}

export default IframeBlock